module.exports = __webpack_public_path__ + "img/Delfina-Jackson-byn.9df6d064.jpg";